export enum ContactOrigin {
    UNKNOWN = -1,
    LIVECHAT = 0,
    MAIL = 1,
    HELPCENTER = 2,
    BLOG = 3,
    FACEBOOK = 4,
    INSTAGRAM = 5,
    CUSTOM_CREATE = 6
}